import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ReactComponent as YellowAlert } from '@assets/svg-imports/Icon-warning.svg';
import { deleteBitBucket } from '@api/api_services';

import { getUserName } from '@util/common_utils';
import {} from '@src/common/ui-constants';
import { BITBUCKET_CONSTANTS } from '../plugin_constants';

function DeleteInstance(props) {
  const deleteBitBucketInstance = async () => {
    try {
      const response = await deleteBitBucket(props.seletedInstance.id);
      if (response?.data?.responseCode == 200) {
        props.closeModal();
        props.reloadTree();
        props.MyAlert.success(`${props.seletedInstance.instanceName} ${BITBUCKET_CONSTANTS.DELETED_SUCCESSFULLY}`);
      } else {
        props.MyAlert.warning(response?.data?.message);
      }
    } catch (err) {
      console.error('Api error ', err);
    }
  };
  return (
    <>
      <Modal
        open={props.openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="focus:outline-none outline-none"
      >
        <Box className="deleteModal focus:outline-none outline-none">
          <div className="headerdelete">
            <div className="successImg">
              <YellowAlert className="svgImgWarning" />
            </div>
            <div className="mt-5 ">
              <div className="flex flex-row">
                <p className="svgYellow fontPoppinsMediumXX2 ml-5">{BITBUCKET_CONSTANTS.WARNING}</p>
                <p className="fontPoppinsMediumXX2 ml-2 delete-content">{BITBUCKET_CONSTANTS.DELETE}</p>
              </div>
              <div className="fontPoppinsRegularLg ml-6 mt-4 flex flex-col delete-content">
                <span className=" fontPoppinsRegularMd">
                  {BITBUCKET_CONSTANTS.DATA_LOST}
                  <br />
                  <span className="fontPoppinsSemiboldMd delete-content">
                    {props?.seletedInstance?.instanceName}
                  </span>{' '}
                  {BITBUCKET_CONSTANTS.INSTANCE} ?
                </span>
                <span className="mt-4 fontPoppinsRegularMd delete-content">{BITBUCKET_CONSTANTS.PROCEED}</span>
              </div>
            </div>
          </div>
          <div className="delete-footer flex -mx-1">
            <button
              className="button-cancel success-instance cursor-pointer fontMontserratMediumXs"
              onClick={props.closeModal}
            >
              {BITBUCKET_CONSTANTS.CANCEL}
            </button>
            <button
              className="delete-button cancel-instance  cursor-pointer fontMontserratMediumXs"
              onClick={deleteBitBucketInstance}
            >
              {BITBUCKET_CONSTANTS.DELETE}
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default DeleteInstance;
